export function getSvgSquare(color: string = 'red', stroke: string = 'black'): string {
  return (
    '<svg width="30" height="30" xmlns="http://www.w3.org/2000/svg"><rect width="20" height="20" x="5" y="2.5" style="fill:' +
    color +
    ';stroke:' +
    stroke +
    ';stroke-width:2.8;opacity:1" /></svg>'
  )
}
